import React, { ComponentType } from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { IContentRelayPlanInfo } from '../models/IContentRelayPlanInfo';
import { ContentRelayPlanTooltip } from './ContentRelayPlanTooltip';

// Centered thumbnail icon for the grid (card) view. The SVG mirrors FolderSwapIcon (the list-view
// icon) so grid and list share the same glyph (W-23846058).
export const getContentRelayPlanDefaultImageUrl = () => imgPath('content-relay-plan-icon.svg');

export class ContentRelayPlanCard extends ContentCard {
  protected getPopoverComponent(): ComponentType<ContentTooltipProps> {
    return ContentRelayPlanTooltip;
  }

  public render() {
    const { hovered, selected, allowDragAndDrop } = this.props;
    const content = this.props.content as IContentRelayPlanInfo;
    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          navigateUrl={getContentUrlForItem(content, this.props.urls)}
          defaultImageUrl={getContentRelayPlanDefaultImageUrl()}
          hovered={hovered}
          selected={selected}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.contentRelayPlanDetails()}
            />
          </span>
          {this.renderActionsMenu()}
        </div>
        {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>}
      </div>
    );
  }
}
